import {getSessionId} from '../session/selectors';
import {getCoverStartDate} from '../session/selectors/financialDetails';
import {getHospitalExcess, getPaymentFrequency, getRate} from '../session/selectors/paymentDetails';
import {getDependants, getPartnerDob, getPolicyHolderDob, getPolicyHolderGender, getScale} from '../session/selectors/personalDetails';
import {getHospitalId} from '../session/selectors/productSelection';
import {getExpectedVisaEndDate} from '../session/selectors/visaDetails';
import {IWHIJoinState} from '../store';

export const getPricingDetails = (state: IWHIJoinState) => state.pricing;
export const getTotalPrice = (state: IWHIJoinState) => getPricingDetails(state).totalPrice;
export const getIsFetchingPrice = (state: IWHIJoinState) => getPricingDetails(state).loadingPrice;
export const getFetchedPrice = (state: IWHIJoinState) => getPricingDetails(state).fetchedPrice;
export const getProducts = (state: IWHIJoinState) => getPricingDetails(state).products || [];
export const getPriceError = (state: IWHIJoinState) => getPricingDetails(state).priceError;

export const getPricingWatchedValues = (state: IWHIJoinState) => ({
  sessionId: getSessionId(state) || null,
  scale: getScale(state) || null,
  dob: getPolicyHolderDob(state) || null,
  partnerDob: getPartnerDob(state) || null,
  startDate: getCoverStartDate(state) || null,
  endDate: getExpectedVisaEndDate(state) || null,
  gender: getPolicyHolderGender(state) || null,
  paymentFrequency: getPaymentFrequency(state) || null,
  rate: getRate(state) || null,
  hospitalProduct: getHospitalId(state) || null,
  excess: getHospitalExcess(state) || null,
  dependants: getDependants(state).length
});

export type PricingWatchedValues = ReturnType<typeof getPricingWatchedValues>;
